import axios from "axios"

export const ReportApi = {
    async Type(data){
        const response = await axios.get(`/api/report/list/type/${data}`)
        return response
    },
    async Assign(data){
        const response = await axios.post(`/api/report/reportuser/assign`,data)
        return response
    },
    async RemoveAssign(data){
        const response = await axios.post(`/api/report/reportuser/removeassign/${data}`)
        return response
    },
    async AssignList(){
        const response = await axios.get('/api/report/reportuser/listassigneuser')
        return response
    },
    async VadeTarhiXGunGecmisFaturalar(day){
        const response = await axios.get('/api/report/get/vadetarihixgungecmisfaturalar/'+day)
        return response
    },
    async ReportOfResponsibleUserApprovement(data){
        const response = await axios.post(`/api/report/responsibleuserapprovementprocess`,data)
        return response
    },
    async ExportReportOfResponsibleUserApprovement(data){
        const response = await axios.post(`api/report/responsibleuserapprovementprocess/exportexcel`,data)
        return response
    },
    async AutoSendInvoiceData(data){
        const response = await axios.post(`api/report/get/list/autosentpaymentlink`,data)
        return response
    },
    async SuccessfulSalesReport(data){
        const response = await axios.post('/api/report/successfulsalesreport',data)
        return response
    },
    async SuccessfulSalesReportStats(data){
        const response = await axios.post('/api/report/successfulsalesreport/stats',data)
        return response
    },
    async SuccessfulSalesReportExport(data){
        const response = await axios.post('/api/report/successfulsalesreport/export',data,{responseType:'blob'})
        return response
    },
    async ReceivableAgingReport(){
        const response = await axios.get('/api/report/get/receivable-aging')
        return response
    },
    async UpcomingDueCollectionsReport(data){
        const response = await axios.post('/api/report/get/upcoming-due',data)
        return response
    },
    async CollectionPerformanceReport(data){
        const response = await axios.post('/api/report/get/collection-performance',data)
        return response
    },
    async CollectionDashboardSummary(){
        const response = await axios.get('/api/report/get/dashboard-summary')
        return response
    },
    async CollectionTrend(data){
        const response = await axios.post('/api/report/get/collection-trend',data)
        return response
    },
    async CariInstallmentOpportunity(){
        const response = await axios.get('/api/report/get/cari-installment-opportunity')
        return response
    },
    async PaymentLinkStatus(){
        const response = await axios.get('/api/report/get/payment-link-status')
        return response
    },
    async SunCampaignActions(){
        const response = await axios.get('/api/report/get/sun-campaign-actions')
        return response
    },
    // Özel Kontrol Stok Raporu — giriş yapan personelin carileri, içinde bulunulan ay
    async SpecialControlStockReport(){
        const response = await axios.get('/api/report/special-control-stock')
        return response
    },
    // Tek cari için özel kontrol stok durumu (cari detay ekranı)
    async CariSpecialControlStockStatus(cariKod){
        const response = await axios.get(`/api/report/special-control-stock/cari/${encodeURIComponent(cariKod)}`)
        return response
    }
}